<!--  -->
<template>
  <div class="home-main">
    <div class="home-main-item">
      <h1 class="home-main-item-title">{{ mentorRole | mentorTypeTitle}} - Mentee List</h1>
      <ul class="home-main-list"
          v-if="menteeList.length>0">
        <li v-for="(item, index) in menteeList"
            :key="index">
          <!-- orange red -->
          <card-mentee @click="linkHandle(item)"
                       :title="item.menteeEnName"
                       :avatar="item.menteeHead||mentteAvatar"
                       :color="item.hasbackLog?'orange':''"
                       :year="item.menteeInYear"
                       :con="item.menteeApplyField"></card-mentee>
        </li>
      </ul>
      <zlr-empty v-else></zlr-empty>
    </div>
    <div v-show="capacityStatus">
      <capacityEditCom :status="capacityStatus" :userRole="mentorRole" :capacityInfos="info" @success="capacityCallback"></capacityEditCom>
    </div>
  </div>
</template>



<script>
// images
import mentteAvatar from '@/assets/images/home/mentee-avatar.svg'
// api
import { getMenteesList } from '@/api/joint'
import { getUserRole, getPaymentinfo } from '@/api/talents'
// less
import './home.less'
// components
import CardMentee from '_c/card-mentee/card-mentee'
import ZlrEmpty from '_c/empty/empty'
import capacityEditCom from '@/view/personal/capacity-edit.vue'
export default {
  name: 'home-main',
  components: {
    CardMentee,
    ZlrEmpty,
    capacityEditCom
  },
  data () {
    return {
      currentYear: 0,
      capacityStatus: false,
      info: {},
      mentteAvatar,
      menteeList: [],
      mentorRole: ''
    }
  },
  computed: {},
  created() {
    this.currentYear = +new Date().getFullYear()
  },
  mounted () {
    // 获取角色
    this.getUserRole()
    //  获取学生列表
    this.getMenteeList()
    // payment详情
    this.getPaymentinfo()
  },
  methods: {
    capacityCallback (status) {
      if (status){
        this.$zlr_message('Edit Success', 'success')
        this.getPaymentinfo()
      }
      this.capacityStatus = false
    },
    getPaymentinfo () {
      getPaymentinfo({}).then(res => {
        this.info = res.data
        let arr = this.info.capacityInfo.capacityInfos.filter(item => ((!(!!item.count) && item.year > this.currentYear))).length
        !!arr && (this.capacityStatus = true);
      })
    },
    // 获取角色
    getUserRole () {
      getUserRole({}).then(res => {
        this.mentorRole = res.data.userInfo.mentorRole
      })
    },
    // 获取学生列表
    getMenteeList () {
      getMenteesList({}).then(res => {
        this.menteeList = res.data.model
      })
    },
    linkHandle ({ menteeNum }) {
      this.$router.push({
        name: 'mentee-main',
        params: {
          id: menteeNum
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
</style>
